import $ from 'jquery'

const suiSplit = () => {
  function hasBgColor(elem, bgColorClass) {
    return elem.filter(bgColorClass).length === 1
  }

  /**
   * Remove bg color from split (this is not allowed as it breaks the padding correction)
   */
  $(`.sui-split[class*="sui-bg-"]`).each(function () {
    this.classList.forEach((entry) => {
      const isBgColorClass = entry.indexOf(`sui-bg-`) === 0
      if (isBgColorClass) {
        $(this).removeClass(entry)
      }
    })
  })

  /**
   * Reduce the top spacing between two splits where all four split halves have the same background color
   */
  $('.sui-split > .sui-split-half:eq(0)').each(function () {
    const firstSplitHalf = $(this)
    const secondSplitHalf = firstSplitHalf.next('.sui-split-half')
    if (!secondSplitHalf.length) return

    this.classList.forEach((entry) => {
      const isBgColorClass = entry.indexOf(`sui-bg-`) === 0
      if (isBgColorClass) {
        const bgColorClass = `.${entry}`
        if (hasBgColor(secondSplitHalf, bgColorClass)) {
          const firstSplitHalfNext = firstSplitHalf.parent().next('.sui-split').find('.sui-split-half:eq(0)')
          const secondSplitHalfNext = firstSplitHalf.parent().next('.sui-split').find('.sui-split-half:eq(1)')

          if (hasBgColor(firstSplitHalfNext, bgColorClass) && hasBgColor(secondSplitHalfNext, bgColorClass)) {
            firstSplitHalfNext.addClass('sui-collapse-padding')
            secondSplitHalfNext.addClass('sui-collapse-padding')
          }
        }
      }
    })
  })

  /**
   * Reduce the top padding on sections that are preceded or followed by split halves with the same bg color.
   */
  $(`.sui-section[class*="sui-bg-"]`).each(function () {
    const section = $(this)
    const splitHalvesPrev = section.prev('.sui-split').children('.sui-split-half')
    const splitHalvesNext = section.next('.sui-split').children('.sui-split-half')

    this.classList.forEach((entry) => {
      if (entry.indexOf(`sui-bg-`) === 0) {
        const bgColorClass = `.${entry}`

        // both preceding split halves have the same bg color
        if (splitHalvesPrev.filter(bgColorClass).length === 2) {
          section.addClass('sui-collapse-padding')

          // only the second preceding split half has the same bg color
        } else if (splitHalvesPrev.filter(bgColorClass).is(':nth-child(2)')) {
          section.addClass('sui-collapse-padding-small')
        }

        // both following split halves have the same bg color
        if (splitHalvesNext.filter(bgColorClass).length === 2) {
          splitHalvesNext.addClass('sui-collapse-padding')

          // only the first following split half has the same bg color
        } else if (splitHalvesNext.filter(bgColorClass).is(':nth-child(1)')) {
          splitHalvesNext.first().addClass('sui-collapse-padding-small')
        }
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', () => suiSplit())
